import { ArrowLeftFromLine } from "lucide-react";
import Button from "@/common/components/Button";
import Spinner from "@/common/components/Spinner";
import Tabs from "@/common/components/Tabs";
import useLogOut from "@/common/hooks/useLogOut";
import useUser from "@/common/hooks/useUser";
import UserData from "@/common/components/UserData";
import LogRequestsTable from "@/common/components/LogRequestsTable";
import GoBackButton from "@/common/components/GoBackButton";

const Show = () => {
  const { data: user, isLoading } = useUser({ id: 'me' });

  const { logOut, isPending } = useLogOut()

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-4 items-center">
          <GoBackButton fallback="/" />
          <h2 className="text-2xl font-bold">Configurações de perfil</h2>
        </div>
        {!isLoading && (
          <div className="flex gap-4">
            <Button
              type="button"
              onClick={() => logOut()}
              variant="error"
              className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)] flex items-center gap-x-2"
            >
              {isPending
                ? (
                  <Spinner className="size-4 fill-white-800" />
                )
                : (
                  <ArrowLeftFromLine size={16} />
                )
              }
              Sair da conta
            </Button>
          </div>
        )}
      </div>
      <Tabs
        tabsListClassName="w-full bg-transparent rounded-none"
        tabsTriggerClassName="h-8 w-full rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
        tabsContentClassName="mt-6"
        tabsList={[
          {
            label: 'Dados',
            value: '',
            body: (
              <UserData user={user} />
            )
          },
          {
            label: 'Histórico de ações',
            value: 'actionsHistory',
            disabled: !user?.id,
            body: (
              <>
                {user && <LogRequestsTable type="AdminUser" id={user.id} />}
              </>
            )
          }
        ]}
      >
      </Tabs>
    </div>
  )
}

export default Show
